import { Component } from '@angular/core';
import { User } from './user';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ux-work-sample-g';
  userModel = new User('');

   showBg:boolean = true;
   showDialog:boolean = true;
   mainContent:boolean = false;
   showError:boolean = false;

  constructor() { }

  onSubmit() {
    console.log('userModel:', this.userModel);
    if ( this.userModel.passcode === 'fb'
      || this.userModel.passcode === 'block' ) {
      this.showBg = false;
      this.showDialog = false;
      this.mainContent = true;
    } else {
      this.showError = true;
    }
    setInterval(() => {
      this.showError = false;;
    }, 2500);
  }
}
